<template>
  <div class="zk-tree-node"
    @click.stop="handleClick"
    :class="{ expanded: childNodeRendered && expanded, 'is-current': $tree.currentNode === _self }">
    <div class="zk-tree-node__content"
      :style="{ 'padding-left': node.level * 16 + 'px' }"
     >
      <span  @click.stop="handleExpandIconClick"
        class="zk-tree-node__expand-icon"
        :class="{ 'is-leaf': node.isLeaf, expanded: !node.isLeaf && expanded }">
      </span>
      <zk-checkbox
        v-if="showCheckbox"
        v-model="node.checked"
        :indeterminate="node.indeterminate"
        @change="handleCheckChange"
        @click.native="handleUserClick">
      </zk-checkbox>
      <span
        v-if="node.loading"
        class="zk-tree-node__icon zk-icon-loading">
      </span>
      <node-content :node="node"></node-content>
    </div>
    <collapse-transition>
      <div
        class="zk-tree-node__children"
        v-show="expanded">
        <zk-tree-node
          :render-content="renderContent"
          v-for="child in node.childNodes"
          :node="child"
          :expanded-all="expandedAll"
          >
        </zk-tree-node>
      </div>
    </collapse-transition>
  </div>
</template>

<script>
  import CollapseTransition from './transition'

  export default {
    name: 'zk-tree-node',

    props: {
      node: {
        default() {
          return {}
        }
      },
      expandedAll: {
        type: Boolean,
        default: false
      },
      props: {},
      renderContent: Function
    },

    components: {
      CollapseTransition,
      NodeContent: {
        props: {
          node: {
            required: true
          }
        },
        render(h) {
          const parent = this.$parent;
          return (
            parent.renderContent
              ? parent.renderContent.call(parent._renderProxy, h, { _self: parent.$parent.$vnode.context, node: this.node })
              : <span class="zk-tree-node__label">{ this.node.label }</span>
          )
        }
      }
    },

    data() {
      return {
        $tree: null,
        expanded: this.expandedAll,
        childNodeRendered: this.expandedAll,
        showCheckbox: false,
        oldChecked: null,
        oldIndeterminate: null
      }
    },

    watch: {
      'node.indeterminate'(val) {
        this.handleSelectChange(this.node.checked, val)
      },

      'node.checked'(val) {
        this.handleSelectChange(val, this.node.indeterminate)
      }
    },

    methods: {
      handleSelectChange(checked, indeterminate) {
        if (this.oldChecked !== checked && this.oldIndeterminate !== indeterminate) {
          this.$tree.$emit('check-change', this.node.data, checked, indeterminate)
        }
        this.oldChecked = checked
        this.indeterminate = indeterminate
      },

      handleClick() {
        this.$tree.currentNode = this
        this.$tree.$emit('node-click', this.node.data, this.node, this)
      },

      handleExpandIconClick(event) {
        let target = event.target
        if (target.tagName.toUpperCase() !== 'DIV' &&
          target.parentNode.nodeName.toUpperCase() !== 'DIV' ||
          target.nodeName.toUpperCase() === 'LABEL') return
        if (this.expanded) {
          this.node.collapse()
          this.expanded = false
        } else {
          this.node.expand(() => {
            this.expanded = true
            this.childNodeRendered = true
          })
        }
      },

      handleUserClick() {
        if (this.node.indeterminate) {
          this.node.setChecked(this.node.checked, true)
        }
      },

      handleCheckChange(ev) {
        if (!this.node.indeterminate) {
          this.node.setChecked(ev.target.checked, true)
        }
      }
    },

    created() {
      var parent = this.$parent

      if (parent.$isTree) {
        this.$tree = parent
      } else {
        this.$tree = parent.$tree
      }

      const tree = this.$tree
      const props = this.props || {}
      const childrenKey = props['children'] || 'children'

      this.$watch(`node.data.${childrenKey}`, () => {
        this.node.updateChildren()
      })

      if (!tree) {
        console.warn('Can not find node\'s tree.')
      }

      this.showCheckbox = tree.showCheckbox
    }
  }
</script>



// WEBPACK FOOTER //
// tree-node.vue?3be20b2d